export default "__VITE_ASSET__yKlg0pKJ__"